import {createSlice} from "@reduxjs/toolkit";
import { getCustomerList } from './action';

const initialState = {
  state: {
    items: [],
    paging: {}
  },
  loading: true,
  error: ''
} as BaseState<CustomerState>

const slice = createSlice({
  name: 'CustomerSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerList.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getCustomerList.fulfilled, (state, action) => {
        const { items, paging } = action.payload
        return {
          state: {
            items,
            paging
          },
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getCustomerList.rejected, (state) => ({
        ...state,
        loading: false,
        error: 'Failed to get customers, please try again'
      })
    )
  }
})

export default slice
